import { API } from "@/lib/api";
import {
  APIService,
  FetchListRequest,
  SuccessFetchListResponse,
} from "@/services/api";
import { ReadInvoiceSpecification } from "@/types/invoiceSpecification";
import { UpdateCosts, CostItem } from "@/types/costs";

const costsAPIService = new APIService<ReadInvoiceSpecification>(
  API.InvoiceSpecifications,
);

export const costsService = {
  getList: (
    invoiceSpecificationId: string,
    fetchParams?: FetchListRequest<CostItem>,
  ): Promise<SuccessFetchListResponse<CostItem>> =>
    costsAPIService.getList(fetchParams, `/${invoiceSpecificationId}/costs`),
  patch: (invoiceSpecificationId: string, costs: UpdateCosts) =>
    costsAPIService.patch(invoiceSpecificationId, costs),
};
